import { render } from "./PublicTelehealth.vue?vue&type=template&id=33be0280&scoped=true&ts=true"
import script from "./PublicTelehealth.vue?vue&type=script&lang=ts"
export * from "./PublicTelehealth.vue?vue&type=script&lang=ts"

import "./PublicTelehealth.vue?vue&type=style&index=0&id=33be0280&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33be0280"]])

export default __exports__